import * as React from 'react';
import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';

import { Supplier } from '../types';

export const SupplierAvatar = (props: {
    record?: Supplier;
    width?: number;
    height?: number;
}) => {
    const { width = 40, height = 40 } = props;
    const record = useRecordContext<Supplier>(props);
    if (!record) return null;
    return (
        <Avatar
            src={record.logo?.src}
            alt={record.nome_fornec || record.nome_razao}
            sx={{
                '& img': { objectFit: 'contain' },
                width,
                height,
                fontSize: height !== 40 ? '0.6rem' : undefined,
                '&.MuiAvatar-colorDefault': {
                    color: 'primary.contrastText',
                },
            }}
        >
            {(record.nome_fornec || record.nome_razao || '?').charAt(0)}
        </Avatar>
    );
};
